import { useEffect, useRef, useState, useCallback, useMemo } from 'react';

import { DEPARTING, RETURNING } from './constants';

const useSelectedFlightOptions = persistedFlightOptions => {
  // The leg on which the flight is changed
  const updatedLeg = useRef(null);
  const [selectedDepartingFlightOption, setDepartingFlightOption] = useState(
    null
  );
  const [selectedReturningFlightOption, setReturningFlightOption] = useState(
    null
  );

  const [isArrowClicked, setIsArrowClicked] = useState(false);

  const setDepartingFlightOptionAndPersistLeg = useCallback(
    newFlightOption => {
      updatedLeg.current = DEPARTING;
      setDepartingFlightOption(newFlightOption);
    },
    [setDepartingFlightOption]
  );

  const setReturningFlightOptionAndPersistLeg = useCallback(
    newFlightOption => {
      // check if new flight option is null
      // if it is null update the state and set the updated leg as departing
      // This is needed when round trip banner is collapsed
      if (!newFlightOption) {
        setReturningFlightOption(null);
        updatedLeg.current = DEPARTING;
      } else {
        updatedLeg.current = RETURNING;
        setReturningFlightOption(newFlightOption);
      }
    },
    [setReturningFlightOption]
  );

  // Set selected flights to the persisted data
  // This happens once, as the persistedFlightOptions data changes
  // only when the query finishes
  useEffect(() => {
    if (persistedFlightOptions[DEPARTING] && !isArrowClicked) {
      setDepartingFlightOptionAndPersistLeg(persistedFlightOptions[DEPARTING]);
    }

    if (persistedFlightOptions[RETURNING] && !isArrowClicked) {
      setReturningFlightOptionAndPersistLeg(persistedFlightOptions[RETURNING]);
    }
  }, [
    persistedFlightOptions,
    setDepartingFlightOptionAndPersistLeg,
    setReturningFlightOptionAndPersistLeg,
    isArrowClicked,
  ]);

  const selectedFlightOptions = useMemo(
    () => ({
      [DEPARTING]: selectedDepartingFlightOption,
      [RETURNING]: selectedReturningFlightOption,
    }),
    [selectedDepartingFlightOption, selectedReturningFlightOption]
  );
  return {
    updatedLeg,
    setDepartingFlightOption: setDepartingFlightOptionAndPersistLeg,
    setReturningFlightOption: setReturningFlightOptionAndPersistLeg,
    selectedFlightOptions,
    setIsArrowClicked,
  };
};

export default useSelectedFlightOptions;
